// 期間の種類
export const dateTypes = [
  { id: '過去14日', label: '過去14日', number: 14, rankRange: 3 },
  { id: '過去28日', label: '過去28日', number: 28, rankRange: 5 },
];
